export default __webpack_public_path__ + "static/media/Logo.c01fc667.png";